// Lead events -> Triple Whale (+ Meta if fbq exists).
// Moved from snippets/fb_custom-events.liquid.

var LEAD_DEDUPE_SECONDS = 5;
var LEAD_DEDUPE_STORAGE_KEY = "lead_dedupe_map_v1"; // { "key": timestampMs }
var LEAD_PENDING_STORAGE_KEY = "pending_lead";
var tripleLeadTries = 0;

function readDedupeMap() {
  try {
    var raw = localStorage.getItem(LEAD_DEDUPE_STORAGE_KEY);
    if (!raw) return {};
    var obj = JSON.parse(raw);
    if (!obj || typeof obj !== "object") return {};
    return obj;
  } catch (e) {
    return {};
  }
}

function writeDedupeMap(map) {
  try {
    localStorage.setItem(LEAD_DEDUPE_STORAGE_KEY, JSON.stringify(map || {}));
  } catch (e) {}
}

function shouldDedupe(key) {
  var map = readDedupeMap();
  var now = Date.now();

  // cleanup old entries
  for (var k in map) {
    if (!map.hasOwnProperty(k)) continue;
    if (now - map[k] > LEAD_DEDUPE_SECONDS * 1000 * 30) delete map[k];
  }

  var last = map[key];
  if (last && now - last < LEAD_DEDUPE_SECONDS * 1000) {
    writeDedupeMap(map);
    return true;
  }

  map[key] = now;
  writeDedupeMap(map);
  return false;
}

function sendTripleLead(props, email) {
  if (typeof window.TriplePixel === "function") {
    if (email) TriplePixel("Contact", { email: email });
    TriplePixel("custom", "leadSubmitted", props);
  } else if (tripleLeadTries < 40) {
    tripleLeadTries++;
    setTimeout(function () {
      sendTripleLead(props, email);
    }, 250);
  }
}

function fireLead(formType, formId, email) {
  email = email ? String(email).trim().toLowerCase() : "";
  var key = (formType + "|" + (formId || "") + "|" + email).toLowerCase();
  if (shouldDedupe(key)) return;

  var props = {
    formType: formType,
    formId: formId || "",
    page: location.pathname,
  };

  if (typeof fbq === "function") {
    fbq("trackCustom", "EmailCaptured", props);
  }

  sendTripleLead(props, email);
}

function savePendingLead(formType, email) {
  try {
    sessionStorage.setItem(
      LEAD_PENDING_STORAGE_KEY,
      JSON.stringify({ formType: formType, email: email || "" }),
    );
  } catch (e) {}
}

function readPendingLead() {
  try {
    var raw = sessionStorage.getItem(LEAD_PENDING_STORAGE_KEY);
    sessionStorage.removeItem(LEAD_PENDING_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

// Klaviyo forms: "submit" only, "stepSubmit" would count multi-step forms twice
function handleKlaviyoFormsEvent(e) {
  if (!e || !e.detail || e.detail.type !== "submit") return;
  var meta = e.detail.metaData || {};
  fireLead("klaviyo", e.detail.formId, meta.$email || meta.email);
}

// Shopify contact/newsletter forms: remember on submit, fire after the success redirect
function handleLeadFormSubmit(e) {
  var form = e.target;
  if (!form || form.tagName !== "FORM") return;

  var typeInput = form.querySelector('input[name="form_type"]');
  var formType = typeInput ? typeInput.value : "";
  if (formType !== "contact" && formType !== "customer") return;

  var emailInput = form.querySelector('[name="contact[email]"]');
  savePendingLead(formType, emailInput ? emailInput.value : "");
}

function checkPendingLead() {
  var url = new URL(window.location.href);
  var posted =
    url.searchParams.get("contact_posted") === "true" ||
    url.searchParams.get("customer_posted") === "true";
  var pending = readPendingLead();

  if (posted) {
    var formType = url.searchParams.get("contact_posted") === "true" ? "contact" : "customer";
    if (pending && pending.formType === formType) {
      fireLead(formType, "", pending.email);
    } else {
      fireLead(formType, "", "");
    }
    url.searchParams.delete("contact_posted");
    url.searchParams.delete("customer_posted");
    history.replaceState(null, "", url.toString());
  } else if (pending && pending.formType === "quiz") {
    fireLead("quiz", "", pending.email);
  }
}

window.fireLead = fireLead;
window.savePendingLead = savePendingLead;

window.addEventListener("klaviyoForms", handleKlaviyoFormsEvent);
document.addEventListener("submit", handleLeadFormSubmit, true);
checkPendingLead();
